const context = require.context('@', true, /\/en\/.*\.js$/)

const locales = context.keys().reduce((acc, key) => {
  const module = context(key)
  if (module && module.default) {
    return { ...acc, ...module.default }
  }
  return acc
}, {})

export default {
  'ec.global.title': '24-hour Government Service Intelligent Assistant',
  
    ...locales,
}
